import React from "react";
import { DefaultButton, TextField } from '@fluentui/react';
import { Persona, PersonaSize } from '@fluentui/react';
import Api from '../../services/Api'

class OwnerSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            owners: [],
            search: ''
        }
    }

    onWrite(e) {
        this.setState({ search: e.target.value });
    }

    _mapOwnerForPeople(user)
    {
        return [{
            name: user.displayName
        }];
    }


    searchForOwner() {
        this.setState({owners : []});

        Api.get('/Owner/?url=' + this.state.search)
        .then(res => res.data)
        .then(posts => {
            this.setState({owners : posts})
        }).catch((error) => {this.setState({error:"Could not return data from server"})});
    }

    render() {
        const error = <div className='errorMessage'>Site not found</div>;
        let owners = this.state.owners ? this.state.owners.map(x =>
            <div style= {{marginTop: '10px'}}>
                <Persona
                    text={x.displayName}
                    secondaryText={x.email}
                    onRenderSecondaryText={() => <a style={personaLinkStyle} href={`mailto:${x.email}`}>{x.email}</a>}
                    size={PersonaSize.size32}
                    showSecondaryText={true}
                    styles={personaStyles}
                />
            </div>
        ) : error;

        return (
            <div style={{ width: '50%' }}>
                <TextField
                    autoComplete ='off'
                    onKeyPress={(ev) => {
                        if (ev.key === 'Enter') {
                            this.searchForOwner();
                            ev.preventDefault();
                        }
                    }}
                    label="Paste site url to get information about administrators"
                    onChange={this.onWrite.bind(this)}
                />
                <DefaultButton onClick = {this.searchForOwner.bind(this)} style={{ marginTop: '8px' }}>Search</DefaultButton>
                <div style={{marginTop: '20px'}}>
                    {owners}
                </div>
            </div>
        );
    }
}

const personaStyles = {
    primaryText: {
        fontWeight: '600'
    }
}
const personaLinkStyle = {
    color: 'inherit',
    textDecoration: 'inherit'
}

export default OwnerSearch


// WEBPACK FOOTER //
// ./src/components/ManageCenter/OwnerSearch.js